// extracted by mini-css-extract-plugin
export default {"banner":"banner__4668+","card-bg":"card-bg__tyDj+","content":"content__OcMSo","title":"title__Ebatm","subtitle":"subtitle__cvbAy","button-group":"button-group__50D51"};